/**
 * EDI Platform clearinghouse helpers for AgenticRCM settings.
 * Integrations UI lives in the Integrations portal (:3060) via ServiceFrame.
 */
import { getServiceApiUrl, SERVICE_PORTS } from '../utils/constants';

const getEdiApiBaseUrl = () => {
  const serviceBase = getServiceApiUrl('EDI_PLATFORM');
  if (serviceBase) {
    return `${serviceBase.replace(/\/$/, '')}/api/v1`;
  }
  if (typeof window !== 'undefined' && window.location) {
    const host = window.location.hostname;
    const isRemote = host !== 'localhost' && host !== '127.0.0.1';
    if (isRemote) return '/edi-api/v1';
    const port = SERVICE_PORTS?.EDI_PLATFORM?.BACKEND ?? 8010;
    return `${window.location.protocol}//${host}:${port}/api/v1`;
  }
  return 'http://localhost:8010/api/v1';
};

const EDI_API_KEY = process.env.REACT_APP_EDI_API_KEY || 'edi_test_api_key_12345';

const getEdiRequestHeaders = () => {
  const headers = { 'Content-Type': 'application/json' };
  const token = localStorage.getItem('token') || localStorage.getItem('auth_token');
  if (token && String(token).trim().startsWith('eyJ')) {
    headers.Authorization = `Bearer ${String(token).trim()}`;
  }
  const envKey = process.env.REACT_APP_EDI_API_KEY || process.env.REACT_APP_API_KEY;
  headers['X-API-Key'] = envKey && String(envKey).trim() ? String(envKey).trim() : EDI_API_KEY;
  return headers;
};

const getOrganizationIdForEdi = () =>
  localStorage.getItem('selectedOrganizationId') || localStorage.getItem('organizationId') || null;

export const integrationService = {
  async fetchEdiClearinghouses() {
    const base = getEdiApiBaseUrl();
    const orgId = getOrganizationIdForEdi();
    const qs = orgId ? `?organization_id=${encodeURIComponent(orgId)}` : '';
    const res = await fetch(`${base}/config/clearinghouses${qs}`, {
      headers: getEdiRequestHeaders(),
    });
    if (!res.ok) {
      const text = await res.text();
      const isHtml = text.trim().toLowerCase().startsWith('<!');
      throw new Error(
        isHtml
          ? `EDI Platform returned an error (${res.status}). Ensure EDI Platform is running at ${base}.`
          : text || res.statusText || 'Failed to fetch clearinghouses from EDI Platform'
      );
    }
    const contentType = res.headers.get('content-type') || '';
    if (!contentType.includes('application/json')) {
      throw new Error('EDI Platform did not return JSON.');
    }
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  },

  getEdiPlatformIntegrationsUrl() {
    if (typeof window !== 'undefined' && window.location) {
      const host = window.location.hostname;
      const port = SERVICE_PORTS?.EDI_PLATFORM?.FRONTEND ?? 3010;
      if (host === 'localhost') return `${window.location.protocol}//${host}:${port}/integrations`;
      return `${window.location.protocol}//${host}/edi/integrations`;
    }
    return 'http://localhost:3010/integrations';
  },
};
